import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveService = async (service,navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
        let Payload  =
        {
            "serviceOfferingID": service.serviceOfferingID,
            "industryID": service.industryID,
            "serviceOfferingName":service.serviceOfferingName,
            "description": service.description,
            "flatRate": service.flatRate,
            "isActive": service.isActive        
          };

          // console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/Service/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      
      const data = await response.json();                      
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else{      
        return data;
      }  
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
